module.exports = __webpack_public_path__ + "static/media/product-feature-tile-icon-01.02c5fb7f.svg";